import { useMutationWithRefresh } from '../useMutationWithRefresh';
import brandService, { BrandForm } from '../../services/brandService';
import { queryKeys } from '../../queryClient';

// สร้างยี่ห้อ
export const useCreateBrand = (options?: { skipSuccessMessage?: boolean }) => {
  return useMutationWithRefresh({
    mutationFn: (data: BrandForm) => brandService.createBrand(data),
    invalidateKeys: [
      queryKeys.brands.all,
      queryKeys.devices.all, // devices อาจแสดง dropdown ยี่ห้อ
      queryKeys.products.all, // products อาจมี relation กับ brand
    ],
    successMessage: options?.skipSuccessMessage ? undefined : 'สร้างยี่ห้อสำเร็จ',
  });
};

// แก้ไขยี่ห้อ
export const useUpdateBrand = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data, ifMatch }: { id: number; data: BrandForm; ifMatch?: string }) =>
      brandService.updateBrand(id, data, ifMatch),
    invalidateKeys: [
      queryKeys.brands.all,
      queryKeys.devices.all, // devices แสดงชื่อยี่ห้อ
      queryKeys.products.all,
      queryKeys.rentals.all, // rentals อาจแสดงยี่ห้อของอุปกรณ์
    ],
    successMessage: 'แก้ไขยี่ห้อสำเร็จ',
  });
};

// ลบยี่ห้อ
export const useDeleteBrand = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => brandService.deleteBrand(id),
    invalidateKeys: [
      queryKeys.brands.all,
      queryKeys.dashboard.summary, // dashboard อาจแสดงจำนวนยี่ห้อ
    ],
    successMessage: 'ลบยี่ห้อสำเร็จ',
  });
};